import { useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "../../../../components/Modal";
import InputForm from "../../../../components/InputForm";
import { Toast } from "../../../../config/Toast";

const Edit = ({ dataDetail, masterBpjs, data, activeModal, closeModal, confirmHandler, year }) => {
  const depositBalance = dataDetail?.depositBalance ?? 0;
  const month = moment(data?.month, "M").format("MMM");
  const yearSelect = year;

  const [paymentDate, setPaymentDate] = useState(data?.payment_date || "");
  const paymentType = data?.payment_type || "";
  const totalMonth = data?.total_month || 1;
  const [note, setNote] = useState(data?.note || "");
  const [alert, setAlert] = useState(false);

  const notifyFailed = (msg) => toast.error(msg, Toast);

  const submitHandler = () => {
    if (!dataDetail?.information?.id) return notifyFailed("Data tidak valid");

    if (paymentType === "deposit") {
      const totalBpjs = totalMonth * masterBpjs;
      const afterAmount = depositBalance - totalBpjs;
      if (afterAmount < 0) {
        setAlert(true);
        notifyFailed("Saldo deposit BPJS tidak cukup");
        return;
      }
    }

    const updatedItem = {
      ...data,
      amount: masterBpjs,
      payment_status: "on_process",
      payment_date: paymentDate,
      payment_type: paymentType,
      total_month: totalMonth,
      id_salary: dataDetail?.id,
      year: yearSelect,
      note,
    };

    confirmHandler(updatedItem);
  };

  const forms = [
    {
      margin: "mb-4",
      label: "Tanggal Pemotongan",
      type: "date",
      id: "payment_date",
      value: paymentDate,
      changeHandler: setPaymentDate,
    },
    {
      margin: "mb-4",
      label: "Note Finance",
      type: "text",
      id: "note",
      value: note,
      changeHandler: setNote,
    },
  ];

  const modalClass = activeModal ? "effect-scale show" : "";
  const modalStyle = activeModal ? { display: "block", paddingRight: "17px" } : {};

  return (
    <Modal
      activeModal={modalClass}
      activeStyle={modalStyle}
      title={`Pembayaran BPJS - ${month} ${yearSelect}`}
      closeClick={closeModal}
      submitHandler={submitHandler}
      type="Masukkan"
      buttonDisable={!paymentDate}
      modalType="modal-lg"
    >
      {alert && (
        <div className="alert alert-danger" role="alert">
          Saldo deposit BPJS tidak cukup
        </div>
      )}

      {forms.map((form) => (
        <InputForm key={form.id} {...form} />
      ))}
    </Modal>
  );
};

export default Edit;
